export default function NotFoundPage() {
  return (
    <div className="text-center">
      <h1 className="text-3xl font-bold underline">404 - Not Found</h1>
    </div>
  );
} 